export default {
  addToCart: {
    id: 'product_page_add_to_cart',
    defaultMessage: 'Add to cart',
  },
  addToCartWithNewWording: {
    id: 'product_page_add_to_cart_label',
    defaultMessage: 'Add to cart',
  },
}
